type OperatorRecord = Record<string, unknown>;

function getScalar(op: OperatorRecord, ...keys: string[]): string | undefined {
  for (const k of keys) {
    const v = op[k];
    if (typeof v === "string" && v.trim()) return v.trim();
  }
  return undefined;
}

export type MakeARequestOption = {
  requestType: string;
  label: string;
  stakeholderPath: string;
};

export const MAKE_A_REQUEST_OPTIONS: MakeARequestOption[] = [
  { requestType: "Ask A Question", label: "Ask a Question", stakeholderPath: "askAQuestionStakeholders" },
  { requestType: "Request A Meeting", label: "Request a Meeting", stakeholderPath: "requestAMeetingStakeholders" },
  { requestType: "Report An Issue", label: "Report an Issue", stakeholderPath: "reportAnIssueStakeholders" },
  { requestType: "Request Information", label: "Request Information", stakeholderPath: "requestInformationStakeholders" },
  {
    requestType: "Register an Identified Site",
    label: "Register an identified site",
    stakeholderPath: "registerAnIdentifiedSiteStakeholders",
  },
  {
    requestType: "Request an Unlisted Operator",
    label: "Request an Unlisted Operator",
    stakeholderPath: "requestAnOperatorStakeholders",
  },
];

export function hasStakeholderListAccess(
  operator: OperatorRecord,
  stakeholderCode: string | null,
  path: string,
): boolean {
  if (!stakeholderCode) return false;
  const raw = operator[path];
  if (!Array.isArray(raw) || raw.length === 0) return false;
  return raw.includes(stakeholderCode);
}

export function visibleMakeARequestOptions(
  operator: OperatorRecord,
  stakeholderCode: string | null,
): MakeARequestOption[] {
  return MAKE_A_REQUEST_OPTIONS.filter((opt) =>
    hasStakeholderListAccess(operator, stakeholderCode, opt.stakeholderPath),
  );
}

export function operatorEmergencyNumber(operator: OperatorRecord): string | undefined {
  return getScalar(operator, "emergencyNumber", "EmergencyNumber");
}

export function hasAnyMakeARequestAccess(operator: OperatorRecord, stakeholderCode: string | null): boolean {
  return visibleMakeARequestOptions(operator, stakeholderCode).length > 0;
}

/** Unlisted operator request is available without operator context (Help page link). */
export function canRequestUnlistedOperator(
  operator: OperatorRecord | null | undefined,
  stakeholderCode: string | null,
): boolean {
  if (!operator || !stakeholderCode) return false;
  return hasStakeholderListAccess(operator, stakeholderCode, "requestAnOperatorStakeholders");
}
